import React from 'react';
import PropTypes from 'prop-types';

import formikPropTypes from '@zr/components/Fields/Formik/formikPropTypes';

import {
  getLegendText,
} from '@zr/jobseeker-public/apps/profile-form/utilities/experienceFormUtilities';

import ExperienceFields from './ExperienceFields';

export function ExperienceFieldset({
  disabled, formikProps, numAdded, enableRichText,
}) {
  return (
    <fieldset className="ExperienceFieldset" disabled={disabled}>
      <legend className="title">{getLegendText(numAdded)}</legend>
      <ExperienceFields formikProps={formikProps} enableRichText={enableRichText} />
    </fieldset>
  );
}

ExperienceFieldset.propTypes = {
  disabled: PropTypes.bool,
  formikProps: formikPropTypes.isRequired,
  numAdded: PropTypes.number,
  enableRichText: PropTypes.bool,
};

ExperienceFieldset.defaultProps = {
  disabled: false,
  numAdded: 0,
  enableRichText: false,
};

export default ExperienceFieldset;
